import * as z from "zod"
import type {NavigationMenuItem} from "@nuxt/ui";
import {RouterNames} from "@/router/routerNames.ts";

export enum Roles {
  Founder = "founder",
  Admin = "admin",
  SubAdmin = "subadmin",
  Student = "student",
  DEMO = "demo"
}

export const passwordRegex = new RegExp(/^(?=.*[A-Za-z0-9]).{6,32}$/)
export const nameRegex = new RegExp(/^.{4,100}$/)
export const passwordErrorMessage = "Password must be 6–32 chars and contain at least one letter or number";
export const PasswordSchema = z.string().regex(
  passwordRegex,
  passwordErrorMessage
)

export const NameSchema = z.string().regex(
  nameRegex,
  "Invalid Name"
)
export const EmailSchema = z.string().regex(
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  "Invalid email format"
)
export const CodeSchema = z.string().regex(
  /^[A-Za-z]+-\d{4}-\d{4}$/,
  "Invalid code format"
)

export const baseLinks: NavigationMenuItem[] =
  [
    {
      label: 'الرئيسية',
      icon: 'hugeicons:home-07',
      to: {
        name:RouterNames.DASHBOARD_HOME
      },
    },
    {
      label: 'ملفي الشخصي',
      icon: 'i-lucide-settings',
      to: {
        name:RouterNames.PROFILE
      },
      defaultOpen: true
    }
  ];

export const adminSideBarLinks: NavigationMenuItem[] =
  [
    {
      label: 'مستخدمين',
      icon: 'mingcute:group-fill',
      to: {
        name:RouterNames.ADMIN_VIEW_USERS
      },
    },
    {
      label: 'درجات',
      icon: 'garden:file-spreadsheet-stroke-12',
      to: {
        name:RouterNames.ADMIN_GRADES
      },
    },
    {
      label: 'مدفوعات',
      icon: 'ant-design:dollar-outlined',
      to: {
        name:RouterNames.ADMIN_PAYMENTS
      },
    },
    {
      label: 'حصص',
      icon: 'ic:baseline-play-lesson',
      to: {
        name:RouterNames.ADMIN_LESSONS
      },
    },
    {
      label: 'مجموعات',
      icon: 'fluent-mdl2:group-list',
      to: {
        name:RouterNames.ADMIN_GROUPS
      },
    },
    {
      label: 'امتحانات',
      icon: 'healthicons:i-exam-qualification-outline',
      to: {
        name: RouterNames.ADMIN_EXAMS
      },
    }
  ];
export const studentSideBarLinks: NavigationMenuItem[] =
  [
    {
      label: 'درجاتي',
      icon: 'carbon:upgrade',
      to: {
        name:RouterNames.STUDENT_GRADES
      },
    },
    {
      label: 'حضوري',
      icon: 'mdi-light:book',
      to: {
        name:RouterNames.STUDENT_ATTENDANCE
      },
    },
    {
      label: 'مدفوعاتي',
      icon: 'streamline-freehand:modern-payment-contactless',
      to: {
        name:RouterNames.STUDENT_PAYMENTS
      },
    },
    {
      label: 'امتحاناتي',
      icon: 'streamline-freehand:modern-payment-contactless',
      to: {
        name:RouterNames.STUDENT_EXAMS
      },
    }
  ];

export const months = [
  {label: 'يناير 1', value: 1},
  {label: 'فبراير 2', value: 2},
  {label: 'مارس 3', value: 3},
  {label: 'أبريل 4', value: 4},
  {label: 'مايو 5', value: 5},
  {label: 'يونيو 6', value: 6},
  {label: 'يوليو 7', value: 7},
  {label: 'أغسطس 8', value: 8},
  {label: 'سبتمبر 9', value: 9},
  {label: 'أكتوبر 10', value: 10},
  {label: 'نوفمبر 11', value: 11},
  {label: 'ديسمبر 12', value: 12}
];
export const years = [
  {label: '2025', value: 2025},
  {label: '2026', value: 2026},
  {label: '2027', value: 2027}
];

export const ROLE_LEVEL: Record<Roles, number> = {
  [Roles.DEMO]: 0,
  [Roles.Student]: 1,
  [Roles.SubAdmin]: 2,
  [Roles.Admin]: 3,
  [Roles.Founder]: 4,
};

export const ROLE_PREFIX: Record<Roles, string> = {
  demo: "dmo",
  founder: "FND",
  admin: "ADM",
  subadmin: "SAD",
  student: "STD",
};

export enum HOST_PROVIDERS {
  HOSTINGER = "hostinger",
  VERCEL = "vercel"
}